<app-toolbar></app-toolbar>
<app-menu fxshow="false" fxshow.gt-sm></app-menu>
<router-outlet></router-outlet>

<app-footer></app-footer>

